import React from 'react';
import { Check } from 'lucide-react';

export const PricingSection = ({ onOpenPopup }) => {
  const plans = [
    {
      name: 'Essentials',
      price: '$45',
      subtitle: '+ Federal Filing Fee',
      features: [
        'Case Review',
        'Case Filing',
        'Basic Search',
        'State E-Filing',
        'Trademark Secured'
      ],
      note: '(Govt. filing fee not included)',
      highlighted: false
    },
    {
      name: 'Enhanced',
      price: '$149',
      subtitle: '+ Federal Filing Fee',
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured',
        'High Satisfaction Rate',
        'Refusal Risk Meter'
      ],
      note: '(Govt. filing fee not included)',
      highlighted: false
    },
    {
      name: 'Deluxe',
      price: '$299',
      subtitle: '+ Federal Filing Fee',
      badge: 'Recommended',
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured',
        'High Satisfaction Rate',
        'Refusal Risk Meter',
        'Trademark Monitoring',
        'Complete Documentation',
        'Digital File',
        'Dedicated Case Manager'
      ],
      note: '(Govt. filing fee not included)',
      highlighted: true
    },
    {
      name: 'Platinum',
      price: '$349',
      subtitle: '+ Federal Filing Fee',
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured',
        'High Satisfaction Rate',
        'Refusal Risk Meter',
        'Trademark Monitoring',
        'Complete Documentation',
        'Digital File',
        'Dedicated Case Manager',
        'High Approval Rate',
        'Comprehensive Search Report',
        'High Priority Service',
        'Cease & Desist Letter'
      ],
      note: '(Govt. filing fee not included)',
      highlighted: false
    }
  ];

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
      {plans.map((plan, index) => (
        <div
          key={index}
          className={`rounded-xl overflow-hidden shadow-lg transition-all duration-300 transform hover:-translate-y-2 flex flex-col ${
            plan.highlighted
              ? 'bg-gradient-to-br from-red-600 to-red-700 text-white ring-4 ring-yellow-400 scale-105'
              : 'bg-white'
          }`}
        >
          {plan.badge && (
            <div className="bg-yellow-400 text-gray-900 text-center py-2 px-4 font-bold text-sm">
              {plan.badge}
            </div>
          )}
          <div className="p-6 flex flex-col flex-1">
            <h3 className={`text-2xl font-bold mb-2 ${plan.highlighted ? 'text-white' : 'text-gray-900'}`}>
              {plan.name}
            </h3>
            <div className="mb-4">
              <div className={`text-4xl font-bold ${plan.highlighted ? 'text-white' : 'text-red-600'}`}>
                {plan.price}
              </div>
              <div className={`text-sm ${plan.highlighted ? 'text-white/80' : 'text-gray-600'}`}>
                {plan.subtitle}
              </div>
            </div>
            <div className={`max-h-64 overflow-y-auto space-y-3 mb-6 pr-2 flex-1 ${plan.highlighted ? 'text-white' : ''}`}>
              {plan.features.map((feature, idx) => (
                <div key={idx} className="flex items-start space-x-2">
                  <Check className={`w-5 h-5 flex-shrink-0 mt-0.5 ${plan.highlighted ? 'text-yellow-400' : 'text-green-600'}`} />
                  <span className="text-sm">{feature}</span>
                </div>
              ))}
            </div>
            <div className={`text-xs mb-4 ${plan.highlighted ? 'text-white/70' : 'text-gray-500'}`}>
              {plan.note}
            </div>
            <button
              onClick={onOpenPopup}
              className={`w-full py-3 rounded-lg font-semibold transition-all duration-300 mt-auto ${
                plan.highlighted
                  ? 'bg-white text-red-600 hover:bg-gray-100'
                  : 'bg-red-600 text-white hover:bg-red-700'
              }`}
            >
              Get Started Today
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};